import ForumPostResponseResource from "common/resources/Project/Config/Forum/ForumPostResponseResource";
import Typography from "components/elements/Typography";
import FilmCrewBadge from "components/materials/FilmCrewBadge";
import I18n from "components/materials/I18n";
import UserBadge from "components/materials/UserBadge";
import { useProjectContext } from "components/pages/FeaturedProjects/contexts/Project";
import { formatUserName } from "utils/UserUtils";
import { formatDateTime } from "utils/DateUtils";
import classes from "./classes.module.scss";

type IProps = {
	post: ForumPostResponseResource;
};

function FilmReaderInfo(props: IProps) {
	return (
		<div className={classes["root"]}>
			<UserBadge user={props.post.creator} className={classes["avatar"]} />
			<div className={classes["publication"]}>
				<div className={classes["by"]}>
					<Typography type="h5" weight="bold">
						{formatUserName(props.post.creator)}
					</Typography>
				</div>
				{props.post.createdAt && (
					<div className={classes["at"]}>
						<Typography type="p" weight="regular" size="small" color="inherit">
							{formatDateTime(props.post.createdAt)}
						</Typography>
					</div>
				)}
			</div>
		</div>
	);
}

function FilmCrewInfo(props: IProps) {
	const { project } = useProjectContext();

	return (
		<div className={classes["root"]}>
			<div className={classes["avatar"]}>
				<FilmCrewBadge project={project} user={props.post.creator} className={classes["avatar"]} />
			</div>
			<div className={classes["publication"]}>
				<div className={classes["by"]}>
					<Typography type="h5" weight="bold">
						{`${I18n.trslt(I18n.asset.common.crew)} ${props.post.project.title}`}
					</Typography>
				</div>
				{props.post.createdAt && (
					<div className={classes["at"]}>
						<Typography type="p" weight="regular" size="small" color="inherit">
							{formatDateTime(props.post.createdAt)}
						</Typography>
					</div>
				)}
			</div>
		</div>
	);
}

export default function PostAuthorInfo(props: IProps) {
	const isPublishedByFilmCrew = props.post.creator.id === props.post.project.author.id;

	if (isPublishedByFilmCrew) {
		return <FilmCrewInfo post={props.post} />;
	} else {
		return <FilmReaderInfo post={props.post} />;
	}
}
